/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var CommentRectTextIcon16Solid = forwardRef('CommentRectTextIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.5 2A2.5 2.5 0 0 0 1 4.5v6a2.5 2.5 0 0 0 2 2.45v1.682a1 1 0 0 0 1.555.832L8.25 13h4.25a2.5 2.5 0 0 0 2.5-2.5v-6A2.5 2.5 0 0 0 12.5 2h-9ZM4 8.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM4.5 6a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1h-7Z" })));
});
